import api, { handleResponse, handleError } from './api';

const feedbackService = {
  async submitFeedback(eventId, data) {
    try {
      const response = await api.post(`/feedback/${eventId}`, data);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  // The most recent ended event you attended but haven't rated (or null).
  async getPending() {
    try {
      const response = await api.get('/feedback/pending');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getEventFeedback(eventId) {
    try {
      const response = await api.get(`/feedback/${eventId}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getFeedbackStats(profileId) {
    try {
      const response = await api.get(`/feedback/stats/${profileId}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default feedbackService;
